"use client";

import { useState } from "react";
import { LuChevronDown } from "react-icons/lu";
import {
  Answer,
  AnswerInner,
  AnswerWrapper,
  Container,
  Description,
  FaqItem,
  FaqList,
  QuestionButton,
  Section,
  Tag,
  Title,
  TitleContainer
} from "./styles";

const faqs = [
  {
    question: "O que é o DentalMap?",
    answer:
      "O DentalMap é um software completo de gestão para clínicas e consultórios odontológicos. Em um só lugar você organiza agenda, prontuário eletrônico, pacientes e financeiro, com tudo armazenado com segurança na nuvem."
  },
  {
    question: "Como funciona o agendamento de consultas no DentalMap?",
    answer:
      "A agenda do DentalMap é online e acessível de qualquer lugar. Você organiza consultas e retornos com poucos cliques, sem papelada, e acompanha os compromissos do consultório a qualquer momento."
  },
  {
    question:
      "O prontuário eletrônico do DentalMap está em conformidade com a LGPD?",
    answer:
      "Sim. Os dados dos pacientes ficam armazenados na nuvem com segurança e o tratamento das informações segue a Lei Geral de Proteção de Dados (LGPD)."
  },
  {
    question: "Preciso instalar algum programa para usar o DentalMap?",
    answer:
      "Não. O DentalMap é 100% na nuvem e funciona direto pelo navegador, em computador, tablet ou celular. Basta ter acesso à internet."
  },
  {
    question: "O DentalMap tem teste grátis?",
    answer:
      "Sim. Você pode experimentar o DentalMap com um período de teste gratuito. Basta criar a sua conta para começar a usar."
  },
  {
    question: "Quanto custa o DentalMap?",
    answer:
      "O DentalMap oferece planos mensal, semestral e anual. Você confere os valores e o que está incluído em cada plano na seção de Preços, aqui mesmo nesta página."
  },
  {
    question:
      "Consigo emitir prescrições, atestados e odontograma pelo DentalMap?",
    answer:
      "Sim. A plataforma gera prescrições e atestados odontológicos e permite registrar o odontograma do paciente diretamente no prontuário eletrônico."
  },
  {
    question:
      "O DentalMap serve para consultórios pequenos e grandes clínicas?",
    answer:
      "Sim. O DentalMap atende desde profissionais autônomos até clínicas com vários dentistas e cadeiras, acompanhando o crescimento do seu negócio."
  },
  {
    question: "Como funciona o suporte do DentalMap?",
    answer:
      "Nosso suporte atende pelo WhatsApp (38) 99956-8521 e pelo e-mail contato@dentalmap.com.br, prontos para ajudar com dúvidas e configurações."
  }
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer
    }
  }))
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) =>
    setOpenIndex((current) => (current === index ? null : index));

  return (
    <Section id="faq">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Container>
        <TitleContainer>
          <Tag>Ajuda & FAQ</Tag>
          <Title>Perguntas frequentes sobre o DentalMap</Title>
          <Description>
            Tire suas dúvidas sobre o software de gestão odontológica do
            DentalMap. Não encontrou o que procurava? Fale com a gente.
          </Description>
        </TitleContainer>

        <FaqList>
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <FaqItem key={faq.question}>
                <QuestionButton
                  type="button"
                  $isOpen={isOpen}
                  aria-expanded={isOpen}
                  onClick={() => toggle(index)}
                >
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "inherit",
                      fontWeight: "inherit",
                      color: "inherit"
                    }}
                  >
                    {faq.question}
                  </h3>
                  <LuChevronDown size={20} />
                </QuestionButton>
                <AnswerWrapper $isOpen={isOpen}>
                  <AnswerInner>
                    <Answer>{faq.answer}</Answer>
                  </AnswerInner>
                </AnswerWrapper>
              </FaqItem>
            );
          })}
        </FaqList>
      </Container>
    </Section>
  );
}
